import angular from 'angular';

import objectsNaviPanelModule from '../objects.navi.panel/objects.navi.panel.module';
import unitSearchHeaderModule from '../unit.search.header/unit.search.header.module';
import unitSearchPanelModule from '../unit.search.panel/unit.search.panel.module';
import commonModule from './common/common.module';

export default angular.module('estoffice.legacy', [
  commonModule.name,
  unitSearchPanelModule.name,
  unitSearchHeaderModule.name,
  objectsNaviPanelModule.name,
]);
